import React, { useEffect, useRef, useState } from "react";
import { Button, Icon, Input, Container, Segment, Grid, Form, Dropdown } from "semantic-ui-react";
import "./MobileViewLive.css";
import { changeFormatLongDateWithOptionalTime, changeInitialScale, loadingShowLogo, numberToCharTG } from "../myfunctions";
import pzkt1 from '../assets/pzkt1.png';
import tglogov6_small from '../assets/tglogov6_small.png';
import wtkuLogo from '../assets/wtku-finaltransparent-e1657718389107.png';
import tgsmallv2 from '../assets/tgsmallv2.png';
import { ConnectWS } from "../ConnectWS";
import { Toaster, toast } from "react-hot-toast";
import { LazyLoadImage } from "react-lazy-load-image-component";
import useWindowDimensions from "../hooks/useWindowDimensions";
import MapaApp from "./MapaApp";
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import { useTranslation } from "react-i18next";
import Marquee from "react-fast-marquee";

export function getColorEvent(statusLive) {
  if (statusLive === 3) return "blue";
  if (statusLive === 2) return "red";
  return "grey";
}

const MobileViewLive = () => {
  const { t: tr, i18n } = useTranslation();
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const { width } = useWindowDimensions();
  const [selectedTournamentId, setSelectedTournamentId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const refs = useRef({});

  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => setDeferredPrompt(null));
    }
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const selectedLanguage = i18n.resolvedLanguage?.startsWith("en") ? "en" : "pl";
  const languageOptions = [
    {
      key: "pl",
      text: width > 600 ? "PL" : "",
      value: "pl",
      flag: { name: "pl" },
    },
    {
      key: "en",
      text: width > 600 ? "EN" : "",
      value: "en",
      flag: { name: "gb" },
    },
  ];

  const handleLanguageChange = (_e, { value }) => {
    changeLanguage(value);
  };

  const renderHeaderBranding = (sizeClass, wtkuClass, isDesktop = false) => (
    <div className={`header-branding ${isDesktop ? "header-branding--desktop" : ""}`}>
      <div className="wtku-logo-wrap">
       
      </div>
      <div className="logos-marquee-wrap">
        <Marquee gradient={false} speed={30} pauseOnHover autoFill style={{ width: "100%" }}>
          <div className="logos-marquee-track"> 
            <img src={wtkuLogo} alt="WTKU" className={wtkuClass} />
            <img src={tglogov6_small} alt="TG" className={sizeClass} />
            <img src={pzkt1} alt="PZKT" className={sizeClass} />
          </div>
        </Marquee>
      </div>
    </div>
  );

  useEffect(() => {
    function statusLive(t) {
      const now = new Date();
      try {
        if (new Date(t?.start_date) > now) return 3;
        if (new Date(t?.start_date) < now && new Date(t?.stop_date) > now) return 2;
        return 1;
      } catch (e) { return 1; }
    }

    function getTournaments() {
      setLoading(true);
      ConnectWS("/karate/getTournaments", null, {}, function (response) {
        if (response && response.status && Number(response.status) === 200) {
          setTournaments(response.data.filter(t => !t.disable_view).map((row) => ({ ...row, statusLive: statusLive(row) }))
            .sort((a, b) => b.statusLive - a.statusLive || new Date(b.start_date) - new Date(a.start_date)));
        } else {
          toast(response);
        }
        setLoading(false);
      });
    }

    changeInitialScale(0.7);
    getTournaments();

    return () => { changeInitialScale(1); };
  }, []);

  const filterBySearchAndSport = (list) => {
    return list.filter((t) => t.tournament_name.toLowerCase().includes(search.toLowerCase()));
  };

  const handleSelectAndScroll = (tournamentId) => {
    setSelectedTournamentId(tournamentId);
    const element = refs.current[tournamentId];
    if (element) element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  const renderTournament = (t) => {
    const isSelected = t.tournament_id === selectedTournamentId;
    const hasImage = !!t.img_file; // Sprawdzenie, czy turniej ma grafikę
    return (
      <Segment key={t.tournament_id} className={`news-card ${isSelected ? 'selected-mobile' : ''}`} onClick={() => setSelectedTournamentId(t.tournament_id)}>
        <div className={`news-image-container-mobile ${!hasImage ? 'no-photo' : ''}`}>
          <LazyLoadImage
            alt={t.tournament_name}
            onClick={(e) => { e.stopPropagation(); t.img_file && setIsOpen(t.img_file); }}
            src={t.img_file || tgsmallv2}
            className={hasImage ? "news-img" : "mobile-placeholder-logo"}
            onError={e => { if (e.target.src !== tgsmallv2) e.target.src = tgsmallv2; }}
          />

          <div className={`news-badge ${getColorEvent(t.statusLive)}`}>
            {t?.statusLive === 3 ? tr("status.planned") : t?.statusLive === 2 ? tr("status.live") : tr("status.finished")}
          </div>
        </div>
        <div className="news-content-mobile">
          <h4 className="news-title">{t.tournament_name}</h4>
          <div className="news-description">
            <p><Icon name="calendar alternate" /> {changeFormatLongDateWithOptionalTime(t.start_date, true)}</p>
            <p><Icon name="marker" /> {t.place ? JSON.parse(t.place)?.address || JSON.parse(t.place)?.description : tr("location.none")}</p>
          </div>
          <div className="news-footer-mobile">
            <div>
              {t?.statusLive === 3 && t.register_online >= 1 ? <Button color={"green"} className="mobile-btn-fix" size="small" onClick={(e) => { e.stopPropagation(); window.location.href = ("https://tg-app.pl/karate"); }}>
                {tr("actions.saveParticipants")}
              </Button> : ""}

              <Button disabled={t.disable_view} basic={t?.statusLive === 3 || t?.statusLive === 2 ? false : true} color={t?.statusLive === 3 ? "blue" : t?.statusLive === 2 ? "red" : "black"} size="small" className="mobile-btn-fix" onClick={(e) => { e.stopPropagation(); window.location.href = ("https://tg-app.pl/tg/" + numberToCharTG(t.tournament_id)); }}>
                {t.disable_view ? tr("actions.pendingPublish") : tr("actions.details")}
              </Button>
            </div>

            <div className="news-icons-mobile">
              {t.statusLive !== 3 && (
                <>
                  <Icon name='winner' className="action-icon medals" onClick={(e) => { e.stopPropagation(); window.location.href = ("https://tg-app.pl/medals/" + numberToCharTG(t.tournament_id)); }} />
                  <Icon name='ordered list' className="action-icon score" onClick={(e) => { e.stopPropagation(); window.location.href = ("https://tg-app.pl/score/" + numberToCharTG(t.tournament_id)); }} />
                </>
              )}
            </div>
          </div>
        </div>
      </Segment>
    );
  };

  const renderTournamentDesktop = (t) => {
    const isSelected = t.tournament_id === selectedTournamentId;
    const hasImage = !!t.img_file; // Sprawdzenie czy jest obrazek
    return (
      <div key={t.tournament_id} ref={(el) => { refs.current[t.tournament_id] = el; }}
        className={`news-card-desktop-horizontal ${isSelected ? 'selected' : ''}`}
        onClick={() => setSelectedTournamentId(t.tournament_id)}>
        <Grid columns={16} style={{ margin: 0 }}>
          <Grid.Row style={{ display: 'flex', alignItems: 'stretch', padding: 0 }}>
            <Grid.Column width={6} className="no-padding">
              {/* DODANO: dynamiczna klasa no-photo */}
              <div className={`news-image-wrapper-horizontal ${!hasImage ? 'no-photo' : ''}`}>

                <LazyLoadImage
                  alt={t.tournament_name}
                  onClick={(e) => { e.stopPropagation(); t.img_file && setIsOpen(t.img_file); }}
                  src={t.img_file || tgsmallv2}
                  className={hasImage ? "news-img-horizontal" : "news-img-horizontal placeholder-logo"}
                  onError={e => { if (e.target.src !== tgsmallv2) e.target.src = tgsmallv2; }}
                />
                <div className={`news-badge-mini ${getColorEvent(t.statusLive)}`}>
                  {t?.statusLive === 3 ? tr("status.planned") : t?.statusLive === 2 ? tr("status.live") : tr("status.finished")}
                </div>
              </div>
            </Grid.Column>
            <Grid.Column width={10} className="no-padding">
              <div className="news-content-horizontal">
                <div className="news-text-block">
                  <h4 className="news-title-desktop">{t.tournament_name}</h4>
                  <div className="news-meta-horizontal">
                    <p><Icon name="calendar alternate" /> {changeFormatLongDateWithOptionalTime(t.start_date, true)}</p>
                    <p className="place-text"><Icon name="marker" /> {t.place ? JSON.parse(t.place)?.address || JSON.parse(t.place)?.description : tr("location.none")}</p>
                  </div>
                </div>
                <div className="news-footer-horizontal">
                  <div>
                    {t?.statusLive === 3 && t.register_online >= 1 ? <Button color={"green"} size="mini" onClick={(e) => { e.stopPropagation(); window.location.href = ("https://tg-app.pl/karate"); }}>
                      {tr("actions.saveParticipants")}
                    </Button> : ""}

                    <Button disabled={t.disable_view} basic={t?.statusLive === 3 || t?.statusLive === 2 ? false : true} color={t?.statusLive === 3 ? "blue" : t?.statusLive === 2 ? "red" : "black"} size="mini" onClick={(e) => { e.stopPropagation(); window.location.href = ("https://tg-app.pl/tg/" + numberToCharTG(t.tournament_id)); }}>
                      {t.disable_view ? tr("actions.pendingPublish") : tr("actions.details")}
                    </Button>
                  </div>
                  <div className="news-icons-horizontal">
                    {t.statusLive !== 3 && (
                      <>
                        <Icon name='winner' className="action-icon medals" onClick={(e) => { e.stopPropagation(); window.location.href = ("https://tg-app.pl/medals/" + numberToCharTG(t.tournament_id)); }} />
                        <Icon name='ordered list' className="action-icon score" onClick={(e) => { e.stopPropagation(); window.location.href = ("https://tg-app.pl/score/" + numberToCharTG(t.tournament_id)); }} />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  };

  return (
    <div className="tg-body">

      {loading ? (
        <div style={{ marginTop: 40 }}>{loadingShowLogo(false)}</div>
      ) : (
        <>
          {width < 900 ? (
            <>
              {deferredPrompt && (
                <Button
                  onClick={handleInstall}
                  color="blue" fluid
                >
                  {tr("app.install")}
                </Button>
              )}
              <div className="search-header-mobile">
                {renderHeaderBranding("mini-logo", "wtku-logo")}
                
                <Form style={{ flex: 1 }}>
                  <Input fluid icon="search" placeholder={tr("app.search")} value={search} onChange={(e) => setSearch(e.target.value)} />
                </Form>
                <div className="language-switcher">
                  {width > 600 && <span className="language-switcher-label">{tr("app.changeLanguage")}:</span>}
                  <Dropdown inline options={languageOptions} value={selectedLanguage} onChange={handleLanguageChange} />
                </div>
              </div>
              <Container style={{ marginTop: 15, paddingBottom: 20 }}>
                <div className="mv-container">
                  {filterBySearchAndSport(tournaments).map(renderTournament)}
                </div>
              </Container>
            </>
          ) : (
            <Grid style={{ margin: 0, height: "100vh" }}>
              <Grid.Row style={{ padding: 0 }}>
                <Grid.Column width={8} style={{ height: "100vh", overflow: "auto", background: '#f7f7f7' }}>
                  <div className="search-header-mobile search-header-desktop">
                    {renderHeaderBranding("d-mini-logo", "wtku-logo-desktop", true)}
                    
                    <Form style={{ flex: "0 0 400px", width: 400 }}>
                      <Input fluid icon="search" placeholder={tr("app.searchTournament")} value={search} onChange={(e) => setSearch(e.target.value)} />
                    </Form>
                    <div className="language-switcher">
                      <Dropdown inline options={languageOptions} value={selectedLanguage} onChange={handleLanguageChange} />
                    </div>
                  </div>
                  <div style={{ marginTop: 10, padding: '0 15px 15px 15px' }}>
                    {filterBySearchAndSport(tournaments).map(renderTournamentDesktop)}
                  </div>
                </Grid.Column>
                <Grid.Column width={8} style={{ padding: 0 }}>
                  <MapaApp selectedTournamentId={selectedTournamentId} dataInMap={filterBySearchAndSport(tournaments)} onMarkerClick={handleSelectAndScroll} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          )}
        </>
      )}
      <Toaster position="top-right" />
      {isOpen && <Lightbox mainSrc={isOpen} onCloseRequest={() => setIsOpen(null)} />}
    
    </div>
  );
};

export default MobileViewLive;